export default class PasswordStrength {
  #length = 8;
  #uppercase = 1;
  #numbers = 1;

  constructor(node) {
    this.passwordInput = node.querySelector(".js-password-input");
    this.lengthValidation = node.querySelector(".js-length-validation-result");
    this.uppercaseValidation = node.querySelector(".js-uppercase-validation-result");
    this.numberValidation = node.querySelector(".js-number-validation-result");
    this.invalidClass = "invalid-no-styling";

    this.passwordInput.addEventListener("input", (e) => {
      this.validatePassword(e.target.value);
    });
  }

  validatePassword(password) {
    this.lengthValidation.classList = "";
    this.uppercaseValidation.classList = "";
    this.numberValidation.classList = "";
    if (this.invalidClass == "invalid-no-styling" && password.length >= this.#length) {
      this.invalidClass = "invalid";
    }
    this.lengthValidation.classList.add(password.length >= this.#length ? "valid" : this.invalidClass);
    this.uppercaseValidation.classList.add((password.match(/[A-Z]/g) || []).length >= this.#uppercase ? "valid" : this.invalidClass);
    this.numberValidation.classList.add((password.match(/[0-9]/g) || []).length >= this.#numbers ? "valid" : this.invalidClass);
  }
}
